export enum CODE_PAYS {
    FRANCE   = 'FR',
}
